import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { Message, MessageBox } from 'element-ui';
const messageDuration = 3000;
// 创建axios实例
const request = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_BASE_API
      : '/api',
  timeout: process.env.VUE_APP_REQUEST_TIMEOUT || 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从vuex获取token
    const token = store.state.token;
    if (token) {
      config.headers['Authorization'] = token;
    }

    // 从vuex获取当前企业id
    const enterpriseId = store.state.currentEnterprise.id;
    if (enterpriseId) {
      // 根据请求方法添加企业id到参数中
      if (config.method === 'get' || config.method === 'GET') {
        // GET请求添加到params
        config.params = config.params || {};
        config.params.enterpriseId = enterpriseId;
      } else {
        // POST等请求添加到data
        config.data = config.data || {};
        config.data.enterpriseId = enterpriseId;
      }
    }
    return config;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);
let isLogout = true;
// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 根据实际业务逻辑处理响应
    if (res.code === 200) {
      return res;
    } else {
      console.error('respnose error:', res.message);
      showMessage(res.msg || 'Error', 'warning');
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  (error) => {
    console.error('响应错误:', error);
    const _response = error.response;
    if (_response) {
      if (isLogout) {
        isLogout = false;
        const errorMessage =
          _response.data === null
            ? '系统内部异常，请联系网站管理员'
            : _response.data.msg;
        switch (_response.status) {
          case 404:
            showMessage('很抱歉，资源未找到');
            isLogout = true;
            break;
          case 403:
            showMessage('很抱歉，您暂无该操作权限');
            isLogout = true;
            break;
          case 401:
            reLogin();
            break;
          case 201:
            showMessage(_response.data.msg, 'warning');
            isLogout = true;
            break;
          default:
            if (errorMessage) {
              if (errorMessage === '已领取的优惠券不能直接下架') {
                break;
              }
              showMessage(errorMessage);
            } else {
              showMessage('请求失败');
            }
            isLogout = true;
            break;
        }
      }
    }
    return Promise.reject(error);
  }
);
function reLogin() {
  MessageBox.alert('登录已过期，请重新登录', '温馨提示', {
    confirmButtonText: '确定',
    showClose: false,
    callback: (action) => {
      isLogout = true;
      store.commit('logout');
      router.push({ path: '/login' });
    }
  });
}
function showMessage(msg, type) {
  console.log('showMessage', msg, type);
  let msgType = 'error';
  if (type) {
    msgType = type;
  }
  Message({
    message: msg,
    type: msgType,
    duration: messageDuration,
    offset: 50
  });
}

export default request;
